module.exports = __webpack_public_path__ + "static/media/boot.773ef49a.svg";